import { LotteryConfigModel } from "../models/lottery-configuration-model";
import { Lottery } from "../../../models/lottery";

export const stastneDatumConfig: LotteryConfigModel = {
    lottery: Lottery.stastneDatum,
    boardCount: 1,
    defaultStake: 50,
    boardLabel: "",
    primaryBoardSize: 1,
    defaultStakeKasa: 5000,
    primaryNumbers: 31,

    secondaryBoardSize: 1,
    tertiaryBoardSize: 1,

    maxDuration: 7,
    basePrice: 50,
    stakeOptions: [50, 100],
    durationTitleShort: "Šťastné datum losujeme každý den.",
};
